<template>
  <form-field-select
    :label="label"
    :value="value"
    @change="handleInput"
    :validation-errors="validationErrors"
  >
    <option :value="null">None</option>
    <option
        v-for="campaign in campaigns"
        :key="campaign.id"
        :value="campaign.id"
    >{{ campaign.label }}</option>
  </form-field-select>
</template>

<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldSelectCampaign",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    label: {
      type: String,
      default: "Campaign"
    },
    validationErrors: {
      type: [
        String,
        Array,
        undefined
      ]
    },
    helpText: {
      type: String
    },
    size: {
      type: String,
      default: "is-small"
    },
    hasEmptyOption: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    campaigns() {
      return this.$store.getters.activeCampaigns;
    },
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);

      this.emitGlobalFieldChangeEvent();
    },
  }
};
</script>

<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles
</style>
